export default __webpack_public_path__ + "static/media/86_desktop.62090e6d.jpg";